import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-card",
  "use": "icon-card-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-card\"><path d=\"M622.933 669.867h64v81.066h-64v-81.066zm81.067 0h64v81.066h-64v-81.066zm81.067 0h64v81.066h-64v-81.066zM85.333 793.6c0 46.933 34.134 85.333 76.8 85.333h699.734c42.666 0 76.8-38.4 76.8-85.333V430.933H85.333V793.6zm776.534-622.933H162.133c-42.666 0-76.8 38.4-76.8 85.333v93.867h853.334V256c0-46.933-34.134-85.333-76.8-85.333z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol